export const SavingsIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.16756 11.2402V12.5936C7.16756 13.7403 6.10089 14.6669 4.78756 14.6669C3.47422 14.6669 2.40088 13.7403 2.40088 12.5936V11.2402C2.40088 12.3869 3.46756 13.2002 4.78756 13.2002C6.10089 13.2002 7.16756 12.3802 7.16756 11.2402Z"
        stroke="none"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...props}
      />
      <path
        d="M7.16687 9.40674C7.16687 9.74007 7.07353 10.0467 6.91353 10.3134C6.5202 10.9601 5.71353 11.3667 4.78019 11.3667C3.84686 11.3667 3.04018 10.9534 2.64685 10.3134C2.48685 10.0467 2.39355 9.74007 2.39355 9.40674C2.39355 8.8334 2.66021 8.32007 3.08687 7.94674C3.52021 7.56674 4.11352 7.34009 4.77352 7.34009C5.43352 7.34009 6.02687 7.5734 6.46021 7.94674C6.90021 8.3134 7.16687 8.8334 7.16687 9.40674Z"
        stroke="none"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...props}
      />
      <path
        d="M7.16756 9.40658V11.2399C7.16756 12.3866 6.10089 13.1999 4.78756 13.1999C3.47422 13.1999 2.40088 12.3799 2.40088 11.2399V9.40658C2.40088 8.25991 3.46756 7.33325 4.78756 7.33325C5.44756 7.33325 6.04091 7.56657 6.47424 7.9399C6.90091 8.31323 7.16756 8.83324 7.16756 9.40658Z"
        stroke="none"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...props}
      />
      <path
        d="M14.6665 7.31327V8.68665C14.6665 9.05331 14.3732 9.35328 13.9998 9.36662H12.6931C11.9731 9.36662 11.3132 8.83995 11.2532 8.11995C11.2132 7.69995 11.3731 7.30662 11.6531 7.03328C11.8998 6.77995 12.2398 6.6333 12.6131 6.6333H13.9998C14.3732 6.64663 14.6665 6.94661 14.6665 7.31327Z"
        stroke="none"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...props}
      />
      <path
        d="M1.3335 6.99992V5.66659C1.3335 3.85325 2.42683 2.58658 4.12683 2.37325C4.30016 2.34658 4.48016 2.33325 4.66683 2.33325H10.6668C10.8402 2.33325 11.0068 2.33991 11.1668 2.36658C12.8868 2.56658 14.0002 3.83992 14.0002 5.66659V6.63326H12.6135C12.2402 6.63326 11.9002 6.77991 11.6535 7.03324C11.3735 7.30658 11.2135 7.69991 11.2535 8.11991C11.3135 8.83991 11.9735 9.36658 12.6935 9.36658H14.0002V10.3333C14.0002 12.3333 12.6668 13.6666 10.6668 13.6666H9.00016"
        stroke="none"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...props}
      />
    </svg>
  )
}
